export function getLoginErrorMessage(error: unknown, restoringSession = false): string {
  const statusCode = (error as { statusCode?: number } | null)?.statusCode
  if (statusCode === 401) {
    return restoringSession
      ? 'Не удалось сохранить вход. Повторите попытку.'
      : 'Неверный логин или пароль. Проверьте данные и попробуйте снова.'
  }
  if (statusCode === 429) {
    return 'Слишком много попыток входа. Подождите немного и попробуйте снова.'
  }
  return 'Не удалось связаться с сервером ERP. Повторите попытку через несколько секунд.'
}
